// extracted by mini-css-extract-plugin
export default {"scroll-area-container":"ScrollArea_scroll-area-container__abn1J","theme-grayscale":"ScrollArea_theme-grayscale__1FmWm"};